<template>
  <div :class="{ 'sidebar-collapsed': sidebarCollapsed }">
    <router-view />
    <notifications />
  </div>
</template>

<script>
import Notifications from 'modules/notifications/Notifications'
import { mapState } from 'vuex'
import flowtype from 'flowtype-js'

export default {
  name: 'App',
  components: { Notifications },
  computed: mapState({
    userFetchInProgress: (store) => store.user.fetchInProgress,
    sidebarCollapsed: (state) => state.common.sidebarCollapsed,
  }),
  mounted() {
    updateFlowType()
  },
}

function updateFlowType() {
  flowtype(document.querySelector('body'), {
    minimum: 320,
    maximum: 1440,
    minFont: 14,
    maxFont: 18,
    fontRatio: 40,
  })
}
</script>

<style lang="scss">
@import '~assets/css/styles.scss';
@import '~animate.css/animate.min.css';
@import '~roboto-fontface/css/roboto/roboto-fontface.css';
@import '~medium-editor/dist/css/medium-editor.min.css';
@import '~medium-editor/dist/css/themes/default.min.css';
</style>
